 export const segmentButtonStyle = (isActive: boolean): React.CSSProperties => ({
    padding: '8px 0',
    borderRadius: 0,
    background: isActive ? '#FF9500' : '#fff',
    color: isActive ? '#fff' : '#374151',
    fontFamily: 'Nunito',
    fontWeight: 600,
    fontSize: 15,
    cursor: 'pointer',
    textAlign: 'center' as const,
    transition: 'all 0.15s',
    userSelect: 'none' as const,
});